<template>
  <div class="impower-member-modal">
    <el-dialog :visible.sync="addModalVisible" width="932px" :before-close="handleClose"  :close-on-click-modal="closeonclickmodal">
      <div slot="title" class="member-modal-title">
        <span class="modal-title-span">{{addModalTitle}}</span>
      </div>
      <div class="member-modal-content">
        <div class="third-rea">
          <div class="third-btn">
            <div class="btn-left">检索条件</div>
            <div class="btn-right">
              <el-button class="btn-two" type="primary" @click="searchInput">查询</el-button>
              <el-button class="btn-two" type="default" @click="resetInput">重置</el-button>
            </div>
          </div>
          <div class="third-search" style="padding-bottom: 0;">
            <el-form
              :inline="true"
              :model="addData"
              label-width="76px"
              @keyup.native.enter="searchInput"
            >
              <div class="search-row">
                <div class="row-item member-search-item">
                  <el-form-item label="登录账号">
                    <el-input
                      :maxlength="30"
                      class="item-input"
                      v-model="addData.account"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="row-item member-search-item">
                  <el-form-item label="姓名">
                    <el-input
                      :maxlength="30"
                      class="item-input"
                      v-model="addData.name"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </el-form>
          </div>
        </div>
        <div class="third-one">
          <el-table
            ref="addMemberTable"
            class="third-tableThree tableThree-impower"
            :data="tableData"
            border
            stripe
            v-loading="loading"
          >
            <el-table-column
              min-width="100px"
              prop="account"
              label="登录账号"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column min-width="100px" prop="realName" label="姓名" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column width="320px" label="权限授予" :show-overflow-tooltip="true">
              <template slot-scope="scope">
									<el-checkbox v-model="scope.row.lookPerm" @change="changeOne(scope.row, 1)">{{addType.type === 'DIR' ? '查看目录' : '查看表'}}</el-checkbox>
									<el-checkbox v-model="scope.row.updateDataPerm"  @change="changeOne(scope.row, 2)">{{addType.type === 'DIR' ? '编辑目录' : '编辑数据'}}</el-checkbox>
									<el-checkbox v-if="addType.type === 'FILE'" v-model="scope.row.updateTablePerm" @change="changeOne(scope.row, 3)">编辑表</el-checkbox>
              </template>
            </el-table-column>
          </el-table>
          <div class="third-page add-modal-page">
            <el-pagination
              class="page-right"
              @current-change="addCurrentChange"
              @size-change="handleSizeChange"
              :current-page="addPage"
              background
              :page-size="addPageSize"
              :page-sizes="[10, 20, 30, 40]"
              layout="total, sizes, prev, pager, next, jumper"
              :total="stuAddTotal"
            ></el-pagination>
          </div>
        </div>
      </div>
      <div slot="footer" class="member-modal-footer">
        <el-button class="modal-footer-two" @click="closeModal">取消</el-button>
        <el-button class="modal-footer-two" type="primary" @click="agreeAdd">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "addMemberModal",
  props: {
    addModalVisible: {
      type: Boolean,
      default: false
    },
    addModalTitle: {
      type: String,
      default: '快速授权'
		},
		addType: {
			type: Object,
			default: () => {
				return {}
			} // 目录或数据表
    },
    //是否点击空白处关闭弹窗
    closeonclickmodal:{
      type: Boolean,
      default: false
    }
	},
	watch: {
		addModalVisible(val) {
			// console.log(val)
			// console.log(this.addType)
			if (val) {
				this.quickList()
			}
		}
	},
	created() {
	},
	data() {
		return {
			addData: {
				account: '', // 账号
				name: '', // 姓名
			}, // 新增数据
			onlyId: 'id', // 添加人员列表的唯一标识
			addPage: 1, // 页码
			addPageSize: 10, // 条数
			stuAddTotal: 0, // 总数
			tableData: [], // 添加弹窗表格
      selectArr: [], // 选中项
      loading: false
		}
	},
  methods: {
		// 选中改变
		changeOne(row, type) {
			// console.log(row, type)
			if (type === 1) {
				if (!row.lookPerm) {
					row.updateDataPerm = false
					row.updateTablePerm = false
				}
			} else if (type === 2) {
				if (!row.updateDataPerm) {
					row.updateTablePerm = false
				} else {
					row.lookPerm = true
				}
			} else if (type === 3) {
				if (row.updateTablePerm) {
					row.lookPerm = true
					row.updateDataPerm = true
				}
			}
			// console.log(row)
			this.selectArr.forEach(element => {
				if (element[this.onlyId] === row[this.onlyId]) {
					this.selectArr.splice(this.selectArr.indexOf(element), 1)
				}
			});
			// console.log(row)
			// if (row.lookPerm || row.updateDataPerm || row.updateTablePerm) {
			// 	this.selectArr.push(row)
      // }
      this.selectArr.push(row)
			console.log(this.selectArr)
		},
		// 搜索
    searchInput() {
			this.addPage = 1
			// console.log(this.addData)
			this.quickList()
    },
    // 重置
    resetInput() {
			this.addData = {
				account: '', // 账号
				name: '', // 姓名
			}
			this.addPage = 1
      this.quickList()
    },
		// 换页选中
		pageChanageSelect(tableData) {
			// console.log(this.selectArr)
			this.selectArr.forEach(element => {
				if (this.selectArr.length !== 0) {
					tableData.forEach(row => {
						if (row[this.onlyId] === element[this.onlyId]) {
							row.lookPerm = element.lookPerm
							row.updateDataPerm = element.updateDataPerm
							row.updateTablePerm = element.updateTablePerm
							// console.log(row)
						}
					});
				}
			});
			// console.log(tableData)
			return tableData
		},
		// 页码变化
    addCurrentChange(val) {
			this.addPage = val
			this.quickList()
    },
    //条数变化
    handleSizeChange(val) {
      this.addPage = 1;
      this.addPageSize = val;
      this.quickList();
    },
    // 弹窗关闭触发
    handleClose() {
      this.addData = {
				account: '', // 账号
				name: '', // 姓名
			}
      this.selectArr = [];
      this.addPage = 1;
      this.$emit("closeAddModal");
    },
    // 确认
    agreeAdd() {
			if (this.selectArr.length !== 0) {
				this.quicksave()
			} else {
				this.addPage = 1
				this.$emit('closeAddModal')
			}
		},
		// 保存授权
		async quicksave() {
			const arr = this.selectArr.map(el => {
				return {
					businessDataId: this.addType.id,
					userId: el.id,
					lookPerm: el.lookPerm,
					updateDataPerm: el.updateDataPerm,
					updateTablePerm: el.updateTablePerm
				}
      })
			const quicksave = await this.$store.dispatch('quicksave', arr)
			console.log(quicksave)
			if (quicksave.data.status === 1000) {
				this.addPage = 1
				this.selectArr = []
				this.$emit('agreeAddMember')
			} else {
				this.$message.error(quicksave.data.msg)
			}
		},
    // 取消
    closeModal() {
      this.addData = {
				account: '', // 账号
				name: '', // 姓名
			}
			this.selectArr = []
			this.addPage = 1
      this.$emit('closeAddModal');
		},
		// 查询授权列表
    async quickList() {
      // console.log(this.addType)
      this.loading = true
      const quickList = await this.$store.dispatch('quickList', {
				tenantId: this.$store.state.user.tenantId,
				businessDataId: this.addType.id,//目录或表id
				dataSortStr: '', // 字段排序
				account: this.addData.account.trim(),//账户
				name: this.addData.name.trim(), //姓名
        pageIndex: this.addPage,
        pageSize: this.addPageSize
      })
      this.loading = false
      // console.log(quickList)
      if (quickList.data.status === 1000) {
        if (quickList.data.result.data.length !== 0) {
					this.tableData = this.pageChanageSelect(quickList.data.result.data)
					this.stuAddTotal = quickList.data.result.total
        } else {
          this.tableData = []
          this.stuAddTotal = 0
				}
      } else {
        this.tableData = [];
        this.stuAddTotal = 0;
      }
    },
  }
};
</script>

<style lang="scss">
.impower-member-modal {
  .el-dialog__header {
    border-bottom: 1px solid #d4d4d7;
    padding: 11px 16px;
    .el-dialog__headerbtn {
      top: 11px;
      right: 16px;
    }
    .member-modal-title {
      .modal-title-icon {
        font-size: 12px;
      }
      .modal-title-span {
        font-size: 12px;
        color: #2e4057;
        font-weight: bold;
      }
    }
  }
  .el-dialog__body {
    height: 504px;
    padding: 8px;
    overflow-y: auto;
    .member-modal-content {
      .member-search-item {
        width: 300px !important;
        text-align: right !important;
        padding-bottom: 8px;
      }
      .tableThree-impower {
        .el-table__body-wrapper {
          height: 320px;
        }
      }
      .add-modal-page {
        font-size: 0;
        .page-left {
          display: inline-block;
          width: 245px;
          text-align: left;
          vertical-align: top;
          .el-button {
            height: 24px;
            // margin-left: 4px !important;
          }
          .btn-one {
            margin-left: 0 !important;
          }
          .left-data {
            padding-left: 8px;
            color: #2e4057;
            font-size: 12px;
          }
        }
        .page-right {
          padding-top: 4px;
          display: inline-block;
          width: calc(100% - 245px);
          padding-right: 0;
        }
      }
    }
  }
  .el-dialog__footer {
    border-top: 1px solid #d4d4d7;
    padding: 16px;
    .member-modal-footer {
      font-size: 0;
      .el-button {
        margin-left: 8px !important;
      }
      .modal-footer-two {
        height: 28px;
      }
    }
  }
}
</style>
